// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAsolvbtc } from "../../../icons/full/build/icon-asolvbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AsolvbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAsolvbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AsolvbtcIcon.displayName = 'AsolvbtcIcon';
}

export default AsolvbtcIcon;